import React from "react";

import { i18, trb } from "@utilities";
import { InputFormField, CheckboxFormField } from "@components/FormField/HookFormFields";
import { FullWidthInputWrapper, StepperFormRow } from "@components";

export const ClientPlanServices = ({ control }) => {
  return (
    <StepperFormRow>
      <FullWidthInputWrapper>
        <p className="form-group-title">{trb(i18.Labels.ClientPlanServices)}</p>
      </FullWidthInputWrapper>

      <FullWidthInputWrapper containerClass="form-step2-checkbox-container">
        <CheckboxFormField
          control={control}
          name="clientPlanServices.0.data.clientPlanServicesCard"
          label={trb(i18.Labels.ClientPlanServicesCard)}
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper containerClass="form-step2-checkbox-container">
        <CheckboxFormField
          control={control}
          name="clientPlanServices.0.data.clientPlanServicesTransf"
          label={trb(i18.Labels.ClientPlanServicesTransf)}
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper containerClass="form-step2-checkbox-container">
        <CheckboxFormField
          control={control}
          name="clientPlanServices.0.data.clientPlanServicesCredSb"
          label={trb(i18.Labels.ClientPlanServicesCredSb)}
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper containerClass="form-step2-checkbox-container">
        <CheckboxFormField
          control={control}
          name="clientPlanServices.0.data.clientPlanServicesDep"
          label={trb(i18.Labels.ClientPlanServicesDep)}
        />
      </FullWidthInputWrapper>

      {/* neccessary for form value */}
      <InputFormField
        control={control}
        name="clientPlanServices.0.data.bankAccType"
        defaultValue="ACCT10"
        className="d-none"
      />
    </StepperFormRow>
  );
};
